import rem from '@/utils/rem';
import { isArray } from "lodash"
import PropTypes from "prop-types";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import { ReactComponent as IconWarning } from '@/assets/svgs/icon-warning-circle.svg'
import ModalSelectedList from '@/components/ModalSelectedList/index';

const AgentPersonaModal = ({ visible, hide, handleSubmission, header, body, dataItems, ["data-testid"]: dataTest }) => {
	return (
		<div data-testid={dataTest}>
			<Modal visible={visible} variant='medium' close={hide}>
				<CardConfigure addHeaderClass="eap-modal__header" >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon--error'}>
											<IconWarning />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{header}
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div data-testid={`${dataTest}-confirm-remove-persona-content`}>
								{isArray(body) && body.length !== 1 ? body.map((item, index) => {
									let style = index === 0 ? "data-table__table__head__row" : null
									return (<div className="data-table__table__head" key={index}>
										<div className={style} style={{ textAlign: "center", paddingBlock: "20px" }}>
											{item}
										</div>
									</div>
									)
								}) :
									<div style={{ textAlign: 'center', paddingBlock: "24px" }}>
										{body[0]}
									</div>
								}
								<br />
								{
									dataItems && (
										<ModalSelectedList
											items={dataItems.filter(item => item.organizationPersonaId !== undefined && item.$selected === false)}
											title="Selected Persona(s)"
											valueKey="name"
										/>
									)
								}
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<button data-testid={`${dataTest}-cancel-remove-persona-button`} className="button--ghost" style={{ width: rem(80) }}
								onClick={() => {
									hide()
								}}
							>Cancel</button>
							<button data-testid={`${dataTest}-confirm-button`} style={{ width: rem(80), marginLeft: rem(10) }}
								onClick={() => {
									handleSubmission()
									hide()
								}}
							>Confirm</button>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</div>
	)
}

AgentPersonaModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	hide: PropTypes.func.isRequired,
	handleSubmission: PropTypes.func.isRequired,
	header: PropTypes.string.isRequired,
	body: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string)
	]).isRequired,
	dataItems: PropTypes.array,
	"data-testid": PropTypes.string
};


export default AgentPersonaModal
